// In-memory session-token carrier (SEC-N3).
//
// The backend sets an HttpOnly + Secure + SameSite session cookie, which
// is the real session carrier. A copy of the token used to be written to
// localStorage as an iOS fallback — but anything that can run script on
// this origin could then read it and take over an admin session.
//
// This module keeps the fallback token in a module-level variable only:
// it survives client-side navigation within the SPA, and is gone on
// refresh/tab-close (at which point the HttpOnly cookie re-authenticates
// via /auth/me). It is never persisted.
//
// One-time migration: any token left in localStorage by a previous
// build is adopted into memory and then erased, so already-signed-in
// users aren't logged out by this change.
let inMemoryToken = null;

const LEGACY_KEY = 'session_token';

try {
  const legacy = localStorage.getItem(LEGACY_KEY);
  if (legacy) {
    inMemoryToken = legacy;
    localStorage.removeItem(LEGACY_KEY);
  }
} catch (e) {
  // Private-mode / storage-disabled browsers — nothing to migrate.
}

export const getSessionToken = () => inMemoryToken;

export const setSessionToken = (token) => {
  inMemoryToken = token || null;
  // Belt-and-braces: make sure no build path can re-persist it.
  try {
    localStorage.removeItem(LEGACY_KEY);
  } catch (e) { /* storage disabled — nothing to clear */ }
};
